import axios from 'axios';
import store from '../store';

function assignStoryToTrigger (data) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/triggers/' + data.triggerId + '/story', data);
}

function getRouteTriggers (routeId) {
  let currentClientId = store.state.client.currentClient.id;
  let currentTour = store.state.tours.currentTour.id;
  let currentTopic = store.state.topics.currentTopic.id;
  if (currentTopic) {
    return axios.get('api/client/' + currentClientId + '/routes/' + routeId + '/tourId/' + currentTour + '/topicId/' + currentTopic + '/triggers');
  } else {
    return axios.get('api/client/' + currentClientId + '/routes/' + routeId + '/triggers');
  }
}

function deleteTrigger (triggerId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.delete('api/client/' + currentClientId + '/trigger/' + triggerId);
}

function checkChannels (tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/checkChannels/tourId/' + tourId);
}

function copyTrigger (triggerId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/triggercopy/' + triggerId);
}

function doStoryFilesExist (tourAndFriendly) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/tour/story', {tourAndFriendly: tourAndFriendly});
}

function removeMoreInfo (trigger) {
  return axios.post('api/client/removeMoreInfo', {trigger: trigger});
}

function deleteNotestrigger (noteid) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/triggerzone/delete-note', {noteid: noteid});
}

function triggerNotes (topicid) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/triggerzone/notes/' + topicid);
}

function triggerNotesByZone (tzid) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/triggerzone/notesbytriggerZone/' + tzid);
}

function saveNotestrigger (notesdata, currentTrigger, currentTopic) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/triggerzone/save-notes', {notesdata: notesdata, currentTrigger: currentTrigger, currentTopic: currentTopic});
}

function updateNotestrigger (notesdata) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/triggerzone/update-notes', {notesdata: notesdata});
}

function triggerIdsNotes (topicid) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/triggerzone/triggerIdsNotes/' + topicid);
}

function topicNotes (topicid) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/topiczone/topicNotes/' + topicid);
}

function saveNotestopic (notesdata, currentTopic) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/topiczone/save-topicNotes', {notesdata: notesdata, currentTopic: currentTopic});
}

function saveTriggerOrder (triggerZoneList) {
  return axios.post('api/client/updateTriggerZoneSequence', {triggerZoneList: triggerZoneList});
}

export {
  assignStoryToTrigger,
  getRouteTriggers,
  deleteTrigger,
  doStoryFilesExist,
  removeMoreInfo,
  triggerNotes,
  saveNotestrigger,
  deleteNotestrigger,
  triggerNotesByZone,
  updateNotestrigger,
  triggerIdsNotes,
  topicNotes,
  saveNotestopic,
  copyTrigger,
  checkChannels,
  saveTriggerOrder
};



// WEBPACK FOOTER //
// ./src/services/TriggerService.js